import { RouteConfig } from "vue-router";
import Layout from "@/views/layout/Layout.vue";
import Splash from "@/views/Splash.vue";
import Auth from "@/views/pages/auth/Auth.vue";
import LayoutList from "@/views/layout/LayoutList.vue";

const routes: RouteConfig[] = [
    {
        path: "/",
        name: "Splash",
        component: Splash,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/auth",
        name: "Auth",
        component: Auth,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/home",
        redirect: "/home",
        component: Layout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "/home",
                name: "home",
                component: () =>
                    import(
                        /* webpackChunkName: "home" */ "@/views/pages/Home.vue"
                    ),
            },
            {
                path: "/create-ticket",
                name: "create-ticket",
                component: () =>
                    import(
                        /* webpackChunkName: "create-ticket" */ "@/views/pages/CreateTicketOpr.vue"
                    ),
            },
            {
                path: "/create-progress/:id",
                name: "progress-create",
                component: () =>
                    import(
                        /* webpackChunkName: "progress-create" */ "@/views/pages/CreateProgress.vue"
                    ),
            },
            {
                path: "/about",
                name: "about",
                component: () =>
                    import(/* webpackChunkName: "about" */ "@/views/About.vue"),
            },
        ],
    },
    {
        path: "/ticket",
        redirect: "/ticket",
        component: LayoutList,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "/ticket",
                name: "ticket",
                component: () =>
                    import(
                        /* webpackChunkName: "ticket" */ "@/views/pages/ListTicket.vue"
                    ),
            },
            {
                path: "/ticket/:search",
                name: "ticket-search",
                component: () =>
                    import(
                        /* webpackChunkName: "ticket-search" */ "@/views/pages/ListTicket.vue"
                    ),
            },
            {
                path: "/notification",
                name: "notification",
                component: () =>
                    import(
                        /* webpackChunkName: "notification" */ "@/views/pages/ListNotification.vue"
                    ),
            },
            {
                path: "/ticket-detail-new/:id",
                name: "ticket detail new",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/DetailTickets.vue"
                    ),
            },
            {
                path: "/detail-ticket/:id",
                name: "detail-ticket",
                component: () =>
                    import(
                        /* webpackChunkName: "detail-ticket" */ "@/views/pages/DetailTicket.vue"
                    ),
            },
            {
                path: "/chat/:id",
                name: "chat",
                component: () =>
                    import(
                        /* webpackChunkName: "chat" */ "@/views/pages/Chat.vue"
                    ),
            },
            {
                path: "/progress/:id",
                name: "progress",
                component: () =>
                    import(
                        /* webpackChunkName: "progress" */ "@/views/pages/Progress.vue"
                    ),
            },
            {
                path: "/profile",
                name: "profile",
                component: () =>
                    import(
                        /* webpackChunkName: "profile" */ "@/views/pages/Profile.vue"
                    ),
            },
            {
                path: "/faq",
                name: "faq",
                component: () =>
                    import(
                        /* webpackChunkName: "faq" */ "@/views/pages/Faq.vue"
                    ),
            },
            {
                path: "/utilities",
                name: "utilities",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Utilities.vue"
                    ),
            },
            {
                path: "/utilities/listrik",
                name: "utilities listrik",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Listrik/Utilities-List-Listrik.vue"
                    ),
            },
            {
                path: "/utilities/gas",
                name: "utilities gas",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Gas/Utilities-List-Gas.vue"
                    ),
            },
            {
                path: "/utilities/air",
                name: "utilities air",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Air/Utilities-List-Air.vue"
                    ),
            },
            {
                path: "/utilities/kue",
                name: "utilities kue",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Kue/Utilities-List-Kue.vue"
                    ),
            },
            {
                path: "/utilities/listrik/add",
                name: "utilities listrik add",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Listrik/Utilities-Detail-Listrik.vue"
                    ),
            },
            {
                path: "/utilities/gas/add",
                name: "utilities gas add",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Gas/Utilities-Detail-Gas.vue"
                    ),
            },
            {
                path: "/utilities/air/add",
                name: "utilities air add",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Air/Utilities-Detail-Air.vue"
                    ),
            },
            {
                path: "/utilities/kue/add",
                name: "utilities kue add",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Kue/Utilities-Detail-Kue.vue"
                    ),
            },
            
            {
                path: "/downtime",
                name: "downtime",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Downtime.vue"
                    ),
            },
            {
                path: "/downtime/list",
                name: "downtime list",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Downtime/Utilities-List-Downtime.vue"
                    ),
            },
            {
                path: "/sparepart",
                name: "sparepart",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Sparepart.vue"
                    ),
            },
            {
                path: "/sparepart/list",
                name: "sparepart list",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Sparepart/Utilities-List-Sparepart.vue"
                    ),
            },
            {
                path: "/downtime/add",
                name: "downtime add",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Downtime/Utilities-Detail-Downtime.vue"
                    ),
            },
            {
                path: "/downtime/task/:id",
                name: "downtime task",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Downtime/Utilities-Input-Downtime.vue"
                    ),
            },
            {
                path: "/downtime/view/:id",
                name: "downtime view",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Downtime/Utilities-View-Downtime.vue"
                    ),
            },
            {
                path: "/sparepart/add",
                name: "sparepart add",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Modules/Sparepart/Utilities-Detail-Sparepart.vue"
                    ),
            },
            {
                path: "/ticket-assessment/:id",
                name: "ticket assessment",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/Assessment.vue"
                    ),
            },
            {
                path: "/ticket-resource-list/:id",
                name: "ticket resource list",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/AdditionalResourceList.vue"
                    ),
            },
            {
                path: "/ticket-resource/:id",
                name: "ticket resource",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/AdditionalResource.vue"
                    ),
            },
            {
                path: "/ticket-resource-view/:id",
                name: "ticket resource view",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/AdditionalResourceView.vue"
                    ),
            },
            {
                path: "/ticket-feedback-list/:id",
                name: "ticket feedback list",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/FeedbackList.vue"
                    ),
            },
            {
                path: "/ticket-feedback/:id",
                name: "ticket feedback",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/Feedback.vue"
                    ),
            },
            {
                path: "/ticket-feedback-edit/:woid/:id",
                name: "ticket feedback edit",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/FeedbackEdit.vue"
                    ),
            },
            {
                path: "/ticket-feedback-view/:id",
                name: "ticket feedback view",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/FeedbackView.vue"
                    ),
            },
            {
                path: "/ticket-feedback-approval/:id",
                name: "ticket feedback approval",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/FeedbackApproval.vue"
                    ),
            },
            {
                path: "/ticket-history/:id",
                name: "ticket history",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/History.vue"
                    ),
            },
            // {
            //     path: "/utilities/detail",
            //     name: "utilities detail",
            //     component: () =>
            //         import(
            //             /* webpackChunkName: "utilities" */ "@/views/pages/Utilities/Utilities-Detail.vue"
            //         ),
            // },

            
            {
                path: "/ticket-activity-list/:id",
                name: "ticket activity list",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/ActivityList.vue"
                    ),
            },
            {
                path: "/ticket-activity/:id",
                name: "ticket activity",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/Activity.vue"
                    ),
            },
            {
                path: "/ticket-activity-view/:id",
                name: "ticket activity view",
                component: () =>
                    import(
                        /* webpackChunkName: "utilities" */ "@/views/pages/WorkOrder/ActivityView.vue"
                    ),
            },
        ],
    },
];

export default routes;
